export default "__VITE_ASSET__BFLESIKq__"